export const DELIVERY_LOCATION_KEY = 'asure_delivery_location';

export const getDeliveryLocation = () => {
    try {
        return JSON.parse(localStorage.getItem(DELIVERY_LOCATION_KEY) || 'null');
    } catch (_) {
        return null;
    }
};

export const saveDeliveryLocation = location => {
    localStorage.setItem(DELIVERY_LOCATION_KEY, JSON.stringify(location));
};

export const getProfilePostalCode = () => {
    try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        return /^\d{6}$/.test(String(user.PostalCode || '')) ? String(user.PostalCode) : '';
    } catch (_) {
        return '';
    }
};

export const filterProductsByDeliveryLocation = products => {
    const location = getDeliveryLocation();
    const pincode = String(location?.postalCode || '').trim();
    const selectedTypes = (location?.productTypes || []).map(type => String(type).toLowerCase().replace(/[^a-z]/g, ''));

    if (!pincode && !selectedTypes.length) return products || [];

    const getField = (product, names) => {
        const normalizedNames = names.map(name => name.toLowerCase());
        const key = Object.keys(product || {}).find(itemKey => normalizedNames.includes(itemKey.toLowerCase()));
        return key ? product[key] : '';
    };

    return (products || []).filter(product => {
        const productPincodes = String(getField(product, ['Pincode', 'PostalCode']))
            .split(',')
            .map(value => value.replace(/\D/g, '').slice(0, 6))
            .filter(Boolean);
        const userType = String(getField(product, ['UserTypeName', 'VendorTypeName', 'SellerTypeName']))
            .toLowerCase().replace(/[^a-z]/g, '');
        const pincodeMatches = !pincode || !productPincodes.length || productPincodes.includes(pincode);
        const typeMatches = !selectedTypes.length || !userType || selectedTypes.some(type => {
            if (type === 'manufacturer') return userType.includes('manufacturer');
            if (type === 'reseller' || type === 'supplier') return userType.includes('reseller') || userType.includes('supplier');
            if (type === 'hardwareshop') return userType.includes('hardware') || userType.includes('hardshop');
            return userType.includes(type);
        });
        return pincodeMatches && typeMatches;
    });
};
